import { EVENT_KEY_ESCAPE } from '../../../../constants/event'
import { SIZE } from '../../../../constants/size'
import { useKeyboardListener } from '../../../../hooks'
import Modal, { Box } from '../../../Modal'
import { RentalPortalViewingProfile } from '../../RentalPortalViewingProfile'

import { QA_NAME_VIEWING_PREVIEW_MODAL } from './RentalPortalViewingPreviewModal.constants'
import { ViewingPreviewModalCloseButton } from './ViewingPreviewModalCloseButton'

import * as styles from './RentalPortalViewingPreviewModal.module.css'

function RentalPortalViewingPreviewModal({
  viewingId,
  onClose,
  onEntityChange,
}) {
  useKeyboardListener({
    callback: onClose,
    dependencies: [onClose],
    eventKey: EVENT_KEY_ESCAPE,
  })

  return (
    <Modal qaName={QA_NAME_VIEWING_PREVIEW_MODAL} onClose={onClose}>
      <Box className={styles.box} size={SIZE.LARGE}>
        <RentalPortalViewingProfile
          isPreview
          CloseButton={ViewingPreviewModalCloseButton}
          ToggleButton={ViewingPreviewModalCloseButton}
          layoutProps={{
            className: styles.preview,
            contentClassName: styles.previewContent,
            scrollWrapperClassName: styles.previewScrollWrapper,
          }}
          viewingId={viewingId}
          onClosePreview={onClose}
          onEntityChange={onEntityChange}
        />
      </Box>
    </Modal>
  )
}

export default RentalPortalViewingPreviewModal
